import { i18n } from '@/i18n';
import { Mod } from '@/models/mod';
import { Steps } from '@/models/steps';
import store from '@/store';
import { resetAllStore } from './local-store';

const submitButtonId = 'gen-add-cart-button';
let submitButton = document.getElementById(submitButtonId) as HTMLLinkElement;

if (submitButton) {
  submitButton.addEventListener('click', (event) => {
    event.preventDefault();
    // store.commit('navigateToStep', Steps.START);
    // store.commit('resetData', Mod.DEBUTANT);
    resetAllStore();
  });
}

const setProductId = (id: string) => {
  submitButton.href = `?add-to-cart=${id}`;
  submitButton.dataset.product_id = id;
};

const getValue = (key: string, formData: any) => {
  return typeof formData[key] === 'object'
    ? formData[key].map((v: string) => i18n.tc(v)).join(', ')
    : key === 'label'
    ? formData[key]
    : i18n.tc(formData[key]);
};

const template = (key: string, value: any) => {
  return `<span class="gen-${key}"><b>${i18n.tc(
    `${key}.step`
  )}</b> ${value}</span>`;
};

const getCoffeeList = (coffee: any) => {
  let coffeeList = `<span class="gen-coffee"><b>${i18n.tc('cart.mixture')}</b>`;
  for (const coffeeItem of coffee) {
    coffeeList += ` ${coffeeItem.name} (${coffeeItem.percent}%),`;
  }
  return coffeeList.slice(0, -1);
};

const setGenText = (data: any) => {
  const addNote = store.getters.getNote;
  let string = '';
  const { formData, coffee } = data;
  const coffeeList = getCoffeeList(coffee);
  string += template('label', getValue('label', formData));
  string += template('amount', getValue('amount', formData));
  string += template('acidity', getValue('acidity', formData));
  string += template('aftertaste', getValue('aftertaste', formData));
  string += template('aroma', getValue('aroma', formData));
  string += template('flavour', getValue('flavour', formData));
  string += template('roastin', getValue('roastin', formData));
  string += coffeeList;
  if (addNote) {
    string += `<span class="gen-notes"><b>${i18n.tc(
      `cart.notes`
    )}</b> ${addNote}</span>`;
  }

  console.log(string);
  submitButton.dataset.gen_text = string;
};

export const setButton = (data: any) => {
  if (!submitButton) {
    console.warn(`Button with id ${submitButtonId} missing.`);
    return false;
  }

  if (!data) {
    console.warn(`No data to send.`);
    return false;
  }

  setProductId(data.article);
  setGenText(data);
  submitButton.click();
};
